<template>
  <ModalLayout v-loading="loadingModal" icon="copy" title="Copy assets to another flight" @close="close">
    <p class="mb-3">
      Copy '<span class="font-medium">{{ asset.name }}</span
      >' to:
    </p>

    <p class="mb-0.5 font-bold">Flight</p>
    <el-select v-model="selectedFlight" placeholder="Select a flight" class="w-full">
      <el-option
        v-for="flight in filteredFlights"
        :key="flight.id"
        :label="flight.name ? flight.name : $period(flight.start_date, flight.end_date)"
        :value="flight.id"
      ></el-option>
    </el-select>

    <template slot="footer">
      <el-button class="font-semibold" @click="close">{{ $t('cancel') }}</el-button>
      <el-button
        class="font-semibold ml-0"
        @click="ctaCopy"
        :loading="loading"
        :disabled="!selectedFlight"
        icon="el-icon-copy-document"
        type="primary"
        >Copy</el-button
      >
    </template>
  </ModalLayout>
</template>
<script>
import ModalLayout from './ModalLayout.vue'
export default {
  name: 'CopyToFlight',
  components: { ModalLayout },
  props: {
    meta: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loadingModal: false,
      loading: false,
      selectedFlight: null,
      flightSelectedName: null,
      flights: [],
    }
  },
  computed: {
    currentFlightId() {
      return Number(this.$route.params.flight_id) || null
    },
    filteredFlights() {
      return this.flights.filter((flight) => flight.status_text === 'New' || flight.status_text === 'Revision Requested')
    },
    asset() {
      return this.meta.asset || {}
    },
  },
  watch: {
    selectedFlight(val) {
      const flight = this.flights.find((item) => item.id === val)
      this.flightSelectedName = flight.name ? flight.name : this.$period(flight.start_date, flight.end_date)
    },
  },
  created() {
    this.init()
  },

  methods: {
    async init() {
      this.loadingModal = true
      try {
        const { data } = await this.axios.get(`/api/social-products/social-boost/campaign/${this.$route.params.id}/flight`)
        this.flights = data.filter((item) => item.id !== this.currentFlightId)
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingModal = false
      }
    },
    close() {
      this.$Modal.instance.isOpen = false
    },
    async ctaCopy() {
      if (!this.selectedFlight) {
        return
      }

      this.loading = true
      try {
        await this.$store.dispatch('socialBoostCampaign/copyAsset', {
          flight_id: this.selectedFlight,
          currentFlight: this.currentFlightId,
          asset_id: this.meta.asset.id,
          asset_name: this.meta.asset.name,
          flightName: this.flightSelectedName,
        })
        this.close()
      } catch (error) {
        console.error('Error copying asset:', error)
      }
      this.loading = false
    },
  },
}
</script>
